import { jsx as _jsx } from "react/jsx-runtime";
import { ORGID } from "@lib";
import { lazy, Suspense, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { useTranslations } from "@rootreeweb/react-translations";
const App = () => {
    const queryClient = new QueryClient();
    const Widget = lazy(() => import("./ImpactReport"));
    const { setTranslations } = useTranslations();
    useEffect(() => {
        setTranslations(window.rtImpactReport);
    }, []);
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(Suspense, { fallback: _jsx("div", { className: "ih-flex ih-w-full ih-justify-center ih-p-4", children: _jsx("h1", { children: "Loading..." }) }), children: _jsx(Widget, { orgId: ORGID }) }) }));
};
export default App;
